/** The moving parts of the bust; the static line-art lives in the component's markup. */

export const mouthRest = 'm256.25 284.01c9.28 7.62 18.08 6.19 29.03-0.47';

export const mouthShapes = {
    rest: mouthRest,
    ee: 'm253 282c10 6 27 6 36 0',
    half: 'm257 281c5 12 20 12 27 0c-9-5-18-5-27 0z',
    open: 'm255 279c6 20 25 20 32 0c-10-6-22-6-32 0z',
    oh: 'm271 276c-7 0-11 5-11 10s4 10 11 10 11-5 11-10-4-10-11-10z',
} as const;

export const speechSequence: (keyof typeof mouthShapes)[] = [
    'half',
    'open',
    'ee',
    'oh',
    'half',
    'rest',
    'open',
    'ee',
    'half',
    'oh',
];

export const leftEyeRest =
    'm235.75 204.5c-4.29 0-7.75-3.46-7.75-7.75 0-4.29 3.46-7.75 7.75-7.75 4.29 0 7.75 3.46 7.75 7.75 0 4.29-3.46 7.75-7.75 7.75z';
export const rightEyeRest =
    'm306.75 202.5c-4.29 0-7.75-3.46-7.75-7.75 0-4.29 3.46-7.75 7.75-7.75 4.29 0 7.75 3.46 7.75 7.75 0 4.29-3.46 7.75-7.75 7.75z';

/** Dizzy eye: a coarse spiral around the origin, so it still reads at ~5px. */
function spiralPath(): string {
    const turns = 1.5;
    const maxRadius = 24;
    const steps = 40;
    const points = Array.from({ length: steps + 1 }, (_, index) => {
        const progress = index / steps;
        const angle = progress * turns * 2 * Math.PI;
        const radius = progress * maxRadius;
        return `${(radius * Math.cos(angle)).toFixed(1)} ${(radius * Math.sin(angle)).toFixed(1)}`;
    });
    return `M${points.join('L')}`;
}

export const spiral = spiralPath();
export const spiralStrokeWidth = 10;
/** Between eye and brow, since the spiral stands in for both. */
export const leftSpiralCenter = { x: 235.75, y: 193 };
export const rightSpiralCenter = { x: 306.75, y: 191 };
